import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { About } from "@/components/site/About";
import { Coverage } from "@/components/site/Coverage";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Footer } from "@/components/site/Footer";

const HomePage = () => (
  <div data-testid="home-page" className="bg-[#0A0A0A] text-white">
    <Nav />
    <main>
      <Hero />
      <Services />
      <About />
      <Coverage />
      <QuoteForm />
    </main>
    <Footer />
    <Toaster
      theme="dark"
      position="top-right"
      toastOptions={{
        style: {
          background: "#121212",
          border: "1px solid #1E5BFF",
          color: "#FFFFFF",
          borderRadius: 0,
        },
      }}
    />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
